import React from "react";
import Fadeup from "../fadeup/Fadeup";


const faq = [
  {
    id: 1,
    question: "How can I submit items for auction?",
    answer:
      "Visit our 'Submit an Item' page on our website or mobile app. Fill out the form and upload images. Our curators will evaluate and get back to you within 5 business days.",
  },
  {
    id: 2,
    question: "What types of items do you accept?",
    answer:
      "We accept fine art, antiques, rare books, collectibles, vintage fashion, and historically significant artifacts. We do not accept replicas or modern mass-market goods.",
  },
  {
    id: 3,
    question: "Do you offer appraisals?",
    answer:
      "Yes, both preliminary digital valuations and certified appraisals. Contact us for individual or bulk assessment rates.",
  },
  {
    id: 4,
    question: "Where are your auctions held?",
    answer:
      "Primarily online and at our London location. Select auctions are hosted internationally at historic venues.",
  },
  {
    id: 5,
    question: "How do I register for an auction?",
    answer:
      "Create an account, verify your identity, and register for the auction you wish to attend or bid in.",
  },
  {
    id: 6,
    question: "Can I bid anonymously?",
    answer:
      "Yes, we offer discreet options such as paddle-only participation or proxy bidding via a private agent.",
  },
  {
    id: 7,
    question: "How are items authenticated?",
    answer:
      "Each item undergoes a multi-stage vetting process by our team and external experts, including provenance research and scientific analysis when necessary.",
  },
  {
    id: 8,
    question: "What are your commission rates?",
    answer:
      "Our standard seller’s commission is between 10–18%, depending on item value and category. We offer customized rates for frequent consignors.",
  },
  {
    id: 9,
    question: "How and when do I receive payment?",
    answer:
      "Payment is processed within 14 business days of successful transaction and item handover. Bank transfer or cheque options are available.",
  },
  {
    id: 10,
    question: "Do you handle shipping?",
    answer:
      "Yes, through insured partners. We offer packing,customs support, and white-glove delivery options worldwide",
  },
];



const Testimonials = () => {
  return (
    <section className="mb-5">
      <div className="sec_pd">
        <Fadeup delay={0.3}>
        <h3 className="text-center border-bottom mt-5 mb-4 mx-3 pb-2 text-black fs_40">
        Frequently Asked Questions
      </h3>
        </Fadeup>
        
      
        <div className="accordion floral-border" id="accordionFAQ">
          {faq.map((item) => (
            <div className="accordion-item" key={item.id}>
              <h2 className="accordion-header " id={`faqHeading${item.id}`}>
                <button
                  className="accordion-button collapsed fw-bold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#faqCollapse${item.id}`}
                  aria-expanded="false"
                  aria-controls={`faqCollapse${item.id}`}
                >
                  {item.question}
                </button>
              </h2>
              <div
                id={`faqCollapse${item.id}`}
                className="accordion-collapse collapse"
                aria-labelledby={`faqHeading${item.id}`}
                data-bs-parent="#accordionFAQ"
              >
                <div className="accordion-body">
                  <p>{item.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
